import { withTranslation } from 'react-i18next'

import Button from '@/ui/Button'

import Modal from '../../../../ui/Modal'
import { ErrorModalDescription, ErrorModalTitle, ErrorModalWrapper } from './ErrorModal.styles'

const RemoveProductModal = ({ onClose, title, description, t }) => {
  return (
    <Modal onClose={onClose}>
      <ErrorModalWrapper>
        <ErrorModalTitle>{title}</ErrorModalTitle>
        <ErrorModalDescription>{description}</ErrorModalDescription>
        <Button onClick={onClose} variant={'outline-dark'}>
          {t('close')}
        </Button>
      </ErrorModalWrapper>
    </Modal>
  )
}

export default withTranslation()(RemoveProductModal)
